import { Button, Col, Dropdown, DropdownButton, Modal, Offcanvas, Row } from 'react-bootstrap'
import MouseDropableSection from '../MouseDropableSection'
import { SECTIONS } from '../PlayerSection/PlayerSection'
import './Discard.scss'
import { useState } from 'react'
import { IMG, hideCard } from '../../Commons/Functions'
import RightClickMenuArea from '../../Commons/RightClickMenuArea'
import HiddenSectionModal from '../OpponentSection/HiddenSectionModal'

export default function Discard(props) {
    const [showDiscardModal, setShowDiscardModal] = useState(false)
    const [showExileModal, setShowExileModal] = useState(false)
    const [showExileHiddenModal, setShowExileHiddenModal] = useState(false)
    const [showSideboardModal, setShowSideboardModal] = useState(false)

    return (
        <MouseDropableSection
            className="discard position-absolute"
            sectionRef={props.discardRef}
            section={SECTIONS.DISCARD}
            cardDraggedRef={props.cardDraggedRef}
            moveCard={props.moveCard}
            repositionCards={props.repositionCards}
        >
            <RightClickMenuArea
                menu={
                    <>
                        <Dropdown.Item onClick={() => setShowDiscardModal(true)}>Show discard</Dropdown.Item>
                        <Dropdown.Item onClick={() => setShowExileModal(true)}>Show removed</Dropdown.Item>
                        <Dropdown.Item onClick={() => setShowExileHiddenModal(true)}>Show removed hidden</Dropdown.Item>
                        <Dropdown.Item onClick={() => setShowSideboardModal(true)}>Show sideboard</Dropdown.Item>
                    </>
                }
                leftClickText="Show"
                leftClick={() => setShowDiscardModal(true)}
                cardDraggedRef={props.cardDraggedRef}
                draggedReplacementText={"Discard"}
            >
                <div>
                    <div className="interaction-zone position-absolute top-0 start-0 w-100 h-100"></div>
                    <p className='position-absolute top-50 z-1 start-50 translate-middle pe-none section-card-count'>{props.sectionCards ? props.sectionCards.length : 0}</p>
                </div>
            </RightClickMenuArea>
            <DiscardModal
                show={showDiscardModal}
                onHide={() => setShowDiscardModal(false)}
                sectionCards={props.sectionCards}
                title="Cards in your discard"
                emptyMessage="Your discard is empty"
                section={SECTIONS.DISCARD}
                moveCard={props.moveCard}
                repositionCards={props.repositionCards}
                opponentIds={props.opponentIds}
                opponentsData={props.opponentsData}
                giveCardAtIndexTo={props.giveCardAtIndexTo}
                allSectionToDeck={props.allSectionToDeck}
            />
            <DiscardModal
                show={showExileModal}
                onHide={() => setShowExileModal(false)}
                sectionCards={props.exileSectionCard}
                title="Cards removed from the game"
                emptyMessage="Your don't have any card removed from the game"
                section={SECTIONS.EXILE}
                moveCard={props.moveCard}
                repositionCards={props.repositionCards}
                opponentIds={props.opponentIds}
                opponentsData={props.opponentsData}
                giveCardAtIndexTo={props.giveCardAtIndexTo}
                allSectionToDeck={props.allSectionToDeck}
            />
            <DiscardModal
                show={showExileHiddenModal}
                onHide={() => setShowExileHiddenModal(false)}
                sectionCards={props.exileHiddenSectionCard}
                title="Cards removed from the game and hidden from your opponents"
                emptyMessage="Your don't have any card removed from the game"
                section={SECTIONS.EXILE_HIDDEN}
                moveCard={props.moveCard}
                repositionCards={props.repositionCards}
                opponentIds={props.opponentIds}
                opponentsData={props.opponentsData}
                giveCardAtIndexTo={props.giveCardAtIndexTo}
                allSectionToDeck={props.allSectionToDeck}
            />
            <SideboardModal
                show={showSideboardModal}
                onHide={() => setShowSideboardModal(false)}
                sectionCards={props.sideboard}
                title="Cards from your sideboard"
                emptyMessage="You don't have any card in your sideboard"
                section={SECTIONS.SIDEBOARD}
                moveCard={props.moveCard}
                repositionCards={props.repositionCards}
                opponentIds={props.opponentIds}
                opponentsData={props.opponentsData}
                giveCardAtIndexTo={props.giveCardAtIndexTo}
                sectionRef={props.discardRef}
                visibleCardsRef={props.visibleCardsRef}
                setSideboard={props.setSideboard}
            />
        </MouseDropableSection>
    )
}

export function OpponentDiscard(props) {
    const [showDiscardModal, setShowDiscardModal] = useState(false)
    const [showExileModal, setShowExileModal] = useState(false)

    return (
        <MouseDropableSection
            className="discard position-absolute"
            sectionRef={props.discardRef}
            section={SECTIONS.DISCARD}
            cardDraggedRef={props.cardDraggedRef}
            moveCard={props.moveCard}
            repositionCards={props.repositionCards}
        >
            <RightClickMenuArea
                menu={
                    <>
                        <Dropdown.Item onClick={() => setShowDiscardModal(true)}>Show discard</Dropdown.Item>
                        <Dropdown.Item onClick={() => setShowExileModal(true)}>Show removed</Dropdown.Item>
                    </>
                }
                leftClickText="Show"
                leftClick={() => setShowDiscardModal(true)}
            >
                <div>
                    <div className="interaction-zone position-absolute top-0 start-0 w-100 h-100"></div>
                    <p className='position-absolute top-50 z-1 start-50 translate-middle pe-none section-card-count'>{props.sectionCards ? props.sectionCards.length : 0}</p>
                </div>
            </RightClickMenuArea>
            <HiddenSectionModal
                cards={props.visibleCards}
                section={SECTIONS.DISCARD}
                show={showDiscardModal}
                handleClose={() => setShowDiscardModal(false)}
                sendToHistory={props.sendToHistory}
                refreshCount={props.refreshCount} />
            <HiddenSectionModal
                cards={props.visibleCards}
                section={SECTIONS.EXILE}
                show={showExileModal}
                handleClose={() => setShowExileModal(false)}
                sendToHistory={props.sendToHistory}
                refreshCount={props.refreshCount} />
        </MouseDropableSection>
    )
}

function SideboardModal(props) {
    function toSection(i, section) {
        if (i < 0 || i > props.sectionCards.length - 1) { return }

        let newSideboard = [...props.sectionCards]
        let newCard = newSideboard.splice(i, 1)[0]
        props.setSideboard(newSideboard)

        let rect = props.sectionRef.current.getBoundingClientRect()

        newCard.position = {
            section: SECTIONS.SIDEBOARD,
            pos: { left: rect.left, top: rect.top },
            cardSize: {
                width: SECTIONS.SECTION_SIZES.DEFAULT * 0.7,
                height: SECTIONS.SECTION_SIZES.DEFAULT
            }
        }
        hideCard(newCard, "yes", props.playerId, props.opponentIds)

        props.visibleCardsRef.current.push(newCard)
        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => {
                props.moveCard(newCard, section)
                props.repositionCards()
            });
        } else {
            setTimeout(() => {
                props.moveCard(newCard, section)
                props.repositionCards()
            }, 0);
        }
    }

    return (
        <Modal className="fullscreen-modal modal-game-panel" show={props.show} onHide={props.onHide} centered>
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
                <Button className="ms-auto" variant="primary" onClick={props.onHide}>
                    Close
                </Button>
            </Modal.Header>
            <Modal.Body>
                {props.sectionCards && props.sectionCards.length == 0 && (
                    <div className='box-container justify-content-center p-5'>{props.emptyMessage}</div>
                )}
                <Row>
                    {props.sectionCards && [...props.sectionCards].map((c, i) => {
                        return (<Col xs={3} key={c.id}>
                            <DiscardCard
                                card={c}
                                index={i}
                                toSection={toSection}
                                section={props.section}
                                opponentIds={props.opponentIds}
                                opponentsData={props.opponentsData}
                                giveCardAtIndexTo={props.giveCardAtIndexTo}
                            />
                        </Col>)
                    })}
                </Row>
            </Modal.Body>
        </Modal>
    )
}

function DiscardModal(props) {
    function toSection(i, section) {
        let c = props.sectionCards[i]
        props.moveCard(c.card, section)
        props.repositionCards()
    }

    return (
        <Modal className="fullscreen-modal modal-game-panel" show={props.show} onHide={props.onHide} centered>
            <Modal.Header>
                <Modal.Title>{props.title} ({props.sectionCards ? props.sectionCards.length : 0})</Modal.Title>
                <Button className="ms-auto" variant="primary" onClick={props.onHide}>
                    Close
                </Button>
            </Modal.Header>
            <Modal.Body>
                {props.sectionCards && props.sectionCards.length == 0 && (
                    <div className='box-container justify-content-center p-5'>{props.emptyMessage}</div>
                )}
                <Row>
                    {props.sectionCards && [...props.sectionCards].reverse().map((c, i) => {
                        return (<Col xs={3} key={c.card.id}>
                            <DiscardCard
                                card={c.card}
                                index={props.sectionCards.length - 1 - i}
                                toSection={toSection}
                                section={props.section}
                                opponentIds={props.opponentIds}
                                opponentsData={props.opponentsData}
                                giveCardAtIndexTo={props.giveCardAtIndexTo}
                            />
                        </Col>)
                    })}
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary"
                    onClick={() => props.allSectionToDeck(props.section)}
                >Shuffle all to deck</Button>
            </Modal.Footer>
        </Modal>
    )
}

function DiscardCard(props) {
    return (
        <div className="modal-panel-card position-relative d-flex flex-column justify-content-between">
            <div className='wrapper'>
                <IMG src={props.card.cardData.face.front.image} className='w-100 h-100' />
                <h3 className='position-absolute bottom-0 start-0'>{props.index + 1}</h3>
                <div className="box-container flex-column m-0 position-absolute start-50 top-50 translate-middle d-flex" style={{ zIndex: 1000 }}>
                    <h5>{props.card.cardData.name}</h5>
                    <Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.STACK)}>Play</Button>
                    <Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.HAND)}>To hand</Button>
                    {props.section != SECTIONS.DISCARD && (<Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.DISCARD)}>Discard</Button>)}
                    {props.section != SECTIONS.EXILE && (<Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.EXILE)}>Remove</Button>)}
                    {props.section != SECTIONS.EXILE_HIDDEN && (<Button className="m-1" onClick={() => props.toSection(props.index, SECTIONS.EXILE_HIDDEN)}>Remove hidden</Button>)}
                    {props.opponentIds && (<DropdownButton drop="top" title="Give to player" className="submenu m-1">
                        {props.opponentIds.map((o, i) => {
                            if (props.opponentsData && props.opponentsData[o]) {
                                return (<Dropdown.Item key={o} onClick={() => {
                                    props.giveCardAtIndexTo(props.index, o, props.section)
                                }}>{props.opponentsData[o].profileData.name}</Dropdown.Item>)
                            }
                        })}
                    </DropdownButton>)}
                </div>
            </div>
        </div>
    )
}